export const LeaderboardMixin = {
  methods: {
    formattedTitle: (iconRequest) => {
      return (iconRequest.title || '').replace(/icon request: /i, '')
    }
  }
}
